"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorProductsSummary = void 0;
const get_distributor_products_summary_stream_1 = require("./get-distributor-products-summary-stream");
const stream_1 = require("../../stream");
const getDistributorProductsSummary = (client) => async () => {
    return (0, stream_1.unwrapStream)(await (0, get_distributor_products_summary_stream_1.getCooperativeProductsSummaryStreamResponse)(client)());
};
exports.getDistributorProductsSummary = getDistributorProductsSummary;
